import styles from './Footer.module.css'
import image from '../../imgs/icone-wolverine-sem-fundo.png'
import Timer from '../Timer'
import { Link, useOutletContext } from 'react-router-dom'

function Footer() {
    const { loginValidate, activePageFormsQuestionsOptions, activePageInfo, activePageQuizBuilder, activePageDemo, activePageMain, activePageMulti, 
        activePageThreeMulti } = useOutletContext()


    return(
        <div className={!loginValidate || activePageFormsQuestionsOptions || activePageInfo || activePageQuizBuilder ? styles.footerForms : styles.footer}>
            {/* Cronômetro no componente header para renderizar toda vez que mudar de página, permitindo assim reiniciar a contagem do tempo */}
            {loginValidate && activePageFormsQuestionsOptions === false && (activePageMain || activePageMulti || activePageThreeMulti || activePageDemo) && <Timer />}
            
            <div className={styles.imgText}>
                <img src={image} alt="icon wolverine" />

                <p>Created by Victor Cardoso. Feel free to connect on  
                    <Link className={styles.textLink} id='contactLink' to="https://www.linkedin.com/in/victor-cardoso-cloud-front/" target="_blank"> Linkedin.</Link>
                </p>
            </div>            

        </div>
    )
}

export default Footer;
